import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { colors } from '../../../../../../../colorVars';
import NumberInputWithUnit from '../../../../../../atomic/inputs/numberInputWithUnit/NumberInputWithUnit';
import MfeRetracementDocumentation from '../../../../documentation/MfeRetracementDocumentation';

import InfoIconComponent from '../../InfoIcon';
import style from './ExitTacticModules.module.css';

export const MfeRetracementModule = ({ state }) => {
  const [mfeRetracement, dispatchMfeRetracement, , setMfeRetracementEnabled] =
    state;
  const [retracePct, setRetracePct] = useState(0);
  const [activationAmount, setActivationAmount] = useState(0);
  useEffect(() => {
    setMfeRetracementEnabled(true);
  }, []);

  useEffect(() => {
    setRetracePct(Number(mfeRetracement.retracePct) * 100 ?? 0);
    setActivationAmount(
      mfeRetracement.activateSetting
        ? mfeRetracement.activateSetting === 'PERCENT'
          ? Number(mfeRetracement.activationValue) * 100
          : mfeRetracement.activationValue
        : 0
    );
  }, [mfeRetracement]);

  // useEffect(() => {
  //   if (mfeRetracement.mfeType === 'byPositionPrice')
  //     dispatchMfeRetracement({ activateSetting: 'PERCENT' });
  // }, [mfeRetracement.mfeType]);

  return (
    <div className={style.moduleStyle}>
      <span className={style.tacticName}>
        <InfoIconComponent docs={MfeRetracementDocumentation} /> MFE Retracement
      </span>
      <div className={style.inputs}>
        <div className={style.inputAndLabel}>
          <p>MFE Type</p>
          <select
            value={mfeRetracement.mfeType}
            onChange={({ target }) =>
              dispatchMfeRetracement({ mfeType: target.value })
            }
          >
            <option value="byPositionPrice">Position Price</option>
            <option value="byPnl">PnL</option>
          </select>
        </div>
        <div className={style.inputAndLabel}>
          <p>Activation Setting</p>
          <select
            // disabled={mfeRetracement.mfeType === 'byPositionPrice'}
            value={mfeRetracement.activateSetting}
            onChange={({ target }) =>
              dispatchMfeRetracement({ activateSetting: target.value })
            }
          >
            <option value="PERCENT">Percent</option>
            <option value="AMOUNT">Dollars</option>
          </select>
        </div>
        <div className={style.inputAndLabel}>
          <p>PnL Type</p>
          <select
            disabled={mfeRetracement.mfeType === 'byPositionPrice'}
            value={mfeRetracement.pnlType}
            onChange={({ target }) =>
              dispatchMfeRetracement({ pnlType: target.value })
            }
          >
            <option value="OVERALL">Overall</option>
            <option value="UNREALIZED">Unrealized</option>
          </select>
        </div>
        <div className={style.inputAndLabel}>
          <p>Activation Amount</p>
          <NumberInputWithUnit
            inputWidth="50px"
            backgroundColor={colors.white}
            direction={
              mfeRetracement.activateSetting === 'PERCENT' ? 'right' : 'left'
            }
            type="number"
            value={activationAmount}
            setValue={setActivationAmount}
            onBlur={(value) => {
              const realValue =
                mfeRetracement.activateSetting === 'PERCENT'
                  ? Number(value) / 100
                  : value;
              dispatchMfeRetracement({
                activationValue: realValue,
              });
            }}
          >
            {mfeRetracement.activateSetting === 'PERCENT' ? '%' : '$'}
          </NumberInputWithUnit>
        </div>
        <div className={style.inputAndLabel}>
          <p>Retrace %</p>
          <NumberInputWithUnit
            backgroundColor={colors.white}
            direction="right"
            type="number"
            value={retracePct}
            setValue={setRetracePct}
            onBlur={(value) =>
              dispatchMfeRetracement({
                retracePct: Number(value) / 100,
              })
            }
          >
            %
          </NumberInputWithUnit>
        </div>
      </div>
    </div>
  );
};

MfeRetracementModule.propTypes = {
  state: PropTypes.array,
};
